export default "__VITE_ASSET__DFX44lHC__"